import objectToFormData from './_objectToFormData';

export const addToCart = (addToCartBtn, addToCartType, addToCartCallback) => {
    const currentBtn = addToCartBtn;
    const addToCartUrl = currentBtn.closest('form').action;
    const data = {
        pid: currentBtn.dataset.pid,
        quantity: 1,
        options: [],
    };

    currentBtn.classList.add('loading');
    currentBtn.disabled = true;

    // Call Add to Cart API
    fetch(addToCartUrl, {
        method: 'POST',
        body: objectToFormData(data),
    }).then((addToCartResponse) => addToCartResponse.json()).then((addToCartResponseJson) => {
        if (addToCartResponseJson.findInStore) {
            currentBtn.classList.remove('loading');
            currentBtn.disabled = false;
            return;
        }

        if (addToCartResponseJson.error) {
            currentBtn.classList.remove('loading');
            currentBtn.disabled = false;

            if (addToCartResponseJson.message) {
                const pdpInfosAction = document.querySelectorAll('[is="m-pdp-infos-action"] #add-product-form-message')[0];
                pdpInfosAction.hidden = false;
                pdpInfosAction.textContent = addToCartResponseJson.message;
            }

            return;
        }
        document.dispatchEvent(new CustomEvent('oNavigation:updateCartCount', {
            detail: {
                productCount: addToCartResponseJson.quantityTotal,
            },
        }));
        document.dispatchEvent(new CustomEvent('oSidebarAjax:prepareAndSendEvent', { detail: { sidebarId: 'o-sidebar-miniCart' } }));

        currentBtn.classList.remove('loading');
        currentBtn.disabled = false;

        if (addToCartResponseJson.gtmData) {
            document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                detail: {
                    data: addToCartResponseJson.gtmData,
                    attributes: {
                        add_to_cart_type: addToCartType,
                        page_type: 'Product Page',
                    },
                },
            }));
        }

        if (addToCartResponseJson.reportingURL) {
            fetch(addToCartResponseJson.reportingURL, {
                method: 'GET',
            });
        }
        if (addToCartCallback) {
            addToCartCallback(addToCartResponseJson);
        }

        if (!addToCartResponseJson.isLast) {
            currentBtn.disabled = true;
            currentBtn.classList.remove('add-to-cart');
        }
    });
};

export default addToCart;
